import React from 'react';

const defaultWrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
};

const defaultImgStyle = {
  width: '100%',
  maxWidth: '100%',
  height: 'auto',
  objectFit: 'cover',
  borderRadius: 5,
  display: 'block',
};

/**
 * Centered proposal image with consistent styling.
 * @param {string} src - Image source (required)
 * @param {string} [alt='Plant proposal'] - Alt text
 * @param {object} [wrapperStyle] - Override or extend wrapper div styles
 * @param {object} [imgStyle] - Override or extend img styles
 */
export default function ProposalImage({ src, alt = 'Plant proposal', wrapperStyle = {}, imgStyle = {} }) {
  const mergedWrapperStyle = { ...defaultWrapperStyle, ...wrapperStyle };
  const mergedImgStyle = { ...defaultImgStyle, ...imgStyle };

  return (
    <div className="quotation-no-break" style={mergedWrapperStyle}>
      <img src={src} alt={alt} style={mergedImgStyle} />
    </div>
  );
}
